"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeFilters = void 0;
exports.matchesEmploymentType = matchesEmploymentType;
exports.matchesFilter = matchesFilter;
exports.groupByFilterType = groupByFilterType;
exports.matchesFilters = matchesFilters;
exports.matchesWorkspaceFilters = matchesWorkspaceFilters;
exports.getSpecificity = getSpecificity;
exports.serializeFilters = serializeFilters;
exports.deserializeFilters = deserializeFilters;
exports.sortBy = sortBy;
exports.matchesTimeFilter = matchesTimeFilter;
const class_transformer_1 = require("class-transformer");
const model_1 = require("./model");
const utils_1 = require("./utils");
class EmployeeFilters {
    constructor(init = {}) {
        this.filters = [{ type: "employeeStatus", value: "active" }];
        this.sortProperty = "lastName";
        this.sortDirection = "ascending";
        this.text = "";
        Object.assign(this, init);
    }
}
exports.EmployeeFilters = EmployeeFilters;
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", String)
], EmployeeFilters.prototype, "text", void 0);
function matchesEmploymentType(employee, type, date) {
    const contract = !date
        ? employee.currentContract
        : typeof date === "string"
            ? (0, utils_1.getContractForDate)(employee.contracts || [], date)
            : (0, utils_1.getAllContractsForRange)(employee.contracts || [], date);
    if (Array.isArray(contract)) {
        return contract.some((c) => c.employmentType === type);
    }
    return (contract === null || contract === void 0 ? void 0 : contract.employmentType) === type;
}
function matchesFilter(filter, { company, employee, date, venue, department, position, timeEntry }) {
    var _a, _b;
    if ((timeEntry === null || timeEntry === void 0 ? void 0 : timeEntry.positionId) && !position) {
        position = timeEntry.positionId;
    }
    if ((timeEntry === null || timeEntry === void 0 ? void 0 : timeEntry.position) && !position) {
        position = timeEntry.position;
    }
    if (typeof position === "number") {
        position = (_a = (0, utils_1.findPositionById)([...company.venues, ...company.archivedVenues], position)) === null || _a === void 0 ? void 0 : _a.position;
    }
    if ((timeEntry === null || timeEntry === void 0 ? void 0 : timeEntry.employeeId) && !employee) {
        employee = (0, utils_1.findEmployeeById)(company.employees, timeEntry.employeeId);
    }
    if (timeEntry && !date) {
        date = timeEntry.date;
    }
    if (["employeeId", "employeeTag", "staffNumber"].includes(filter.type) && timeEntry && !employee) {
        return false;
    }
    const positions = getPositionsByFilter(filter, company);
    switch (filter.type) {
        case "venue":
        case "department":
        case "position":
            return ((!venue ||
                venue.departments.some((dep) => dep.positions.some((pos) => positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === pos.id)))) &&
                (!department || department.positions.some((pos) => positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === pos.id))) &&
                (!position || (positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === position.id))) &&
                (!employee || employee.positions.some((pos) => positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === pos.id))));
        case "employmentType":
            if (!employee) {
                return false;
            }
            return matchesEmploymentType(employee, filter.value, date);
        case "employeeStatus":
            if (!employee) {
                return false;
            }
            return employee.status === filter.value;
        case "employeeId":
            return ((!venue ||
                venue.departments.some((dep) => dep.positions.some((pos) => positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === pos.id)))) &&
                (!department || department.positions.some((pos) => positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === pos.id))) &&
                (!position || (positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === position.id))) &&
                (!employee || employee.id === filter.value));
        case "staffNumber":
            return ((!venue ||
                venue.departments.some((dep) => dep.positions.some((pos) => positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === pos.id)))) &&
                (!department || department.positions.some((pos) => positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === pos.id))) &&
                (!position || (positions === null || positions === void 0 ? void 0 : positions.some((p) => p.id === position.id))) &&
                (!employee || employee.staffNumber === filter.value));
        case "employeeTag":
            if (!employee) {
                return false;
            }
            return (_b = employee.tags) === null || _b === void 0 ? void 0 : _b.some((tag) => tag.id === filter.value);
        case "costCenter": {
            const constCenter = company.costCenters.find((cc) => cc.number === filter.value);
            if (!constCenter) {
                return false;
            }
            return matchesFilters(constCenter.entities, {
                company,
                employee,
                date,
                venue,
                department,
                position,
            });
        }
    }
}
function groupByFilterType(filters) {
    const filterTypes = {
        workspace: [],
        employee: [],
        employmentType: [],
        employeeStatus: [],
        employeeTag: [],
        costCenter: [],
    };
    for (const filter of filters) {
        switch (filter.type) {
            case "venue":
            case "department":
            case "position":
                filterTypes.workspace.push(filter);
                break;
            case "employeeId":
            case "staffNumber":
                filterTypes.employee.push(filter);
                break;
            case "employmentType":
                filterTypes.employmentType.push(filter);
                break;
            case "employeeStatus":
                filterTypes.employeeStatus.push(filter);
                break;
            case "employeeTag":
                filterTypes.employeeTag.push(filter);
                break;
            case "costCenter":
                filterTypes.costCenter.push(filter);
                break;
        }
    }
    return filterTypes;
}
function matchesFilters(filters, context) {
    const filterTypes = groupByFilterType(filters);
    return [...Object.values(filterTypes)].every((filters) => !filters.length || filters.some((filter) => matchesFilter(filter, context)));
}
function matchesWorkspaceFilters(filters, context) {
    const workspaceFilters = groupByFilterType(filters).workspace;
    return !workspaceFilters.length || workspaceFilters.some((filter) => matchesFilter(filter, context));
}
function getSpecificity(filters) {
    const types = new Set(filters.map((f) => f.type));
    let score = types.size;
    if (types.has("employeeId")) {
        score += 10;
    }
    return score;
}
function serializeFilters(filters) {
    return btoa(JSON.stringify(filters)).replace(/=/g, "");
}
function deserializeFilters(filters) {
    return JSON.parse(atob(filters));
}
/**
 * Optimizes sorting by properties that might have complicated calculations
 * by pre-calculating the sort properties and sorting by them.
 * The tradeoff is that we instantiate 3 new arrays and 2 new functions and NOT mutating the input array in place.
 */
function sortBy(arr, fnBy, sortDirection) {
    // Pre-calculate sort properties once
    const sortProps = new Array(arr.length);
    const indices = new Array(arr.length);
    for (let i = 0; i < arr.length; i++) {
        sortProps[i] = fnBy(arr[i], i);
        indices[i] = i;
    }
    // sort indices by sort properties
    indices.sort((indexA, indexB) => {
        const aVal = sortProps[indexA];
        const bVal = sortProps[indexB];
        return aVal < bVal ? -1 : aVal > bVal ? 1 : 0;
    });
    // create new array with sorted entries
    const ascending = sortDirection === "ascending";
    const result = new Array(arr.length);
    for (let i = 0; i < arr.length; i++) {
        result[i] = ascending ? arr[indices[i]] : arr[indices[arr.length - i - 1]];
    }
    return result;
}
function getPositionsByFilter(filter, company) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    switch (filter.type) {
        case "venue":
            return ((_b = (_a = (0, utils_1.getVenue)([...company.venues, ...company.archivedVenues], filter.value)) === null || _a === void 0 ? void 0 : _a.departments.flatMap((department) => department.positions)) !== null && _b !== void 0 ? _b : []);
        case "department":
            return ((_d = (_c = (0, utils_1.getDepartment)([...company.venues, ...company.archivedVenues], filter.value).department) === null || _c === void 0 ? void 0 : _c.positions) !== null && _d !== void 0 ? _d : []);
        case "position": {
            const position = (_e = (0, utils_1.findPositionById)([...company.venues, ...company.archivedVenues], filter.value)) === null || _e === void 0 ? void 0 : _e.position;
            return position ? [position] : [];
        }
        case "employeeId":
            return (_g = (_f = (0, utils_1.findEmployeeById)(company.employees, filter.value)) === null || _f === void 0 ? void 0 : _f.positions) !== null && _g !== void 0 ? _g : [];
        case "staffNumber":
            return (_j = (_h = (0, utils_1.findEmployeeByStaffNumber)(company.employees, filter.value)) === null || _h === void 0 ? void 0 : _h.positions) !== null && _j !== void 0 ? _j : [];
        case "employeeStatus":
        case "employmentType":
        case "employeeTag":
        case "costCenter":
            return [];
    }
}
function matchesTimeFilter({ date, start, end, type, }, { from, to, fromRule, toRule }) {
    if (type !== model_1.TimeEntryType.Work) {
        return true;
    }
    if (typeof start === "string") {
        start = new Date(start);
    }
    if (typeof end === "string") {
        end = new Date(end);
    }
    const [filterStart, filterEnd] = (0, utils_1.parseTimes)(date, from, to);
    let startOk = false;
    let endOk = false;
    switch (fromRule) {
        case "equal":
            startOk = !filterStart || (!!start && filterStart.getTime() === start.getTime());
            break;
        case "open":
            // Does it end before our filter starts (within or later)
            startOk = !filterStart || !end || end > filterStart;
            break;
        default:
            startOk = !filterStart || ((!start || start >= filterStart) && (!end || end > filterStart));
            break;
    }
    switch (toRule) {
        case "equal":
            endOk = !filterEnd || (!!end && filterEnd.getTime() === end.getTime());
            break;
        case "open":
            // does it start before our filter ends (within or earlier)
            endOk = !filterEnd || !start || start < filterEnd;
            break;
        default:
            endOk = !filterEnd || ((!end || end <= filterEnd) && (!start || start < filterEnd));
            break;
    }
    return startOk && endOk;
}
//# sourceMappingURL=filters.js.map